    <template>
  <div class="Login">
    <div class="login-form">
      <h1>{{$t('welcomeBack')}}</h1>
      <span class="login-type">{{$t('loginAndenjoy')}}</span>
      <div class="input-box">
        <label for="email">{{$t('email')}}</label>
        <input type="text" name="email" :placeholder="$t('enterEmail')" v-model="email" />
        <label for="Password">{{$t('password')}}</label>
        <input
          type="password"
          name="Password"
          :placeholder="$t('enterPassword')"
          v-model="password"
          id="loginPswd"
        />
      </div>
      <button class="logIn-button" id="loginBtn" @click="logInCelebrity">{{$t('login')}}</button>
    </div>
    <div class="loader" v-if="loading">
      <img src="../assets/images/gif-loader.gif" />
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import VueCookie from "vue-cookie";
import Btn from "./Btn";
import Dashboard from "../views/Dashboard";
import { toaster } from "../utils/helper";
export default {
  name: "logIn",
  components: {
    Btn,
    Dashboard
  },
  data() {
    return {
      email: "",
      password: "",
      loading: false
    };
  },
  computed: {
    ...mapGetters(["isUserRegister"])
  },
  methods: {
    logInCelebrity() {
      if (
        !new RegExp(
          /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/g
        ).test(this.email)
      ) {
        toaster(
          this,
          this.$t("invalidLoginPass"),
          "bottom-center",
          2000
        );
      } else if (!new RegExp(/^(?=.*\d).{4,8}$/g).test(this.password)) {
        toaster(
          this,
          this.$t("invalidLoginPass"),
          "bottom-center",
          2000
        );
      } else {
        const obj = {
          email: this.email,
          password: this.password
        };
        this.loading = true;
        this.$store
          .dispatch({ type: "verifyCelebrity", payload: obj })
          .then(data => {
            this.loading = false;
            if (data.data.status === "success") {
              VueCookie.set("user", JSON.stringify(data.data));
              this.$router.push("/dashboard");
            } else {
              toaster(
                this,
                this.$t("invalidLoginPass"),
                "bottom-center",
                2000
              );
              this.loading = false;
            }
          })
          .catch(err => {
            this.loading = !this.loading;
            toaster(
              this,
              this.$t("somethingWentwrong"),
              "bottom-center",
              2000
            );
          });
      }
    }
  },
  mounted() {
    var input = document.getElementById("loginPswd");
    input.addEventListener("keyup", function(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        document.getElementById("loginBtn").click();
      }
    });
    if (
      JSON.parse(VueCookie.get("user")) &&
      JSON.parse(VueCookie.get("user")).celebrity_id
    ) {
      this.$router.push("/dashboard");
    }
  }
};
</script>

